module.exports = __webpack_public_path__ + "img/complaint-ojk.9bfac4e9.png";